import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { AttributesService } from '../../_ecomservices/attributes.service';

@Component({
  selector: 'app-attributes',
  templateUrl: './attributes.component.html',
  styleUrls: ['./attributes.component.css']
})
export class AttributesComponent implements OnInit {

  displayedColumns: string[] = ['AttributeName', 'Slug',  
    'ParentAttribute', 'Description', 'Count'];
  
    dataSource: MatTableDataSource<any>;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    searchKey: string;

  constructor(
    private titleService: Title,
    public attributesService: AttributesService,) { }
 

    ngOnInit() 
    {
      this.titleService.setTitle('Attribute List');
    }
  
  
    applyFilter()
    {
      this.dataSource.filter = this.searchKey.trim().toLocaleLowerCase();
    }
  
    onSearchClear()
    {
      this.searchKey = "";
      this.applyFilter();
    }

    onAttributeFormSubmit() {}

    onFileChange(event){

    }

}
